import React from 'react';
import { 
  ShoppingBag, 
  Heart, 
  GraduationCap, 
  Building2, 
  Banknote, 
  PlayCircle,
  TrendingUp,
  Users
} from 'lucide-react';

const Solutions = () => {
  const solutions = [
    {
      icon: ShoppingBag,
      title: 'E-Commerce Platforms',
      description: 'Complete online retail solutions with inventory management, payment processing, and customer analytics.',
      color: 'from-cyan-500 to-teal-500'
    },
    {
      icon: Heart,
      title: 'Healthcare Applications',
      description: 'HIPAA-compliant telehealth platforms, patient management systems, and medical record solutions.',
      color: 'from-rose-500 to-pink-500'
    },
    {
      icon: GraduationCap,
      title: 'Education Technology',
      description: 'Interactive learning platforms, virtual classrooms, and comprehensive student management systems.',
      color: 'from-violet-500 to-purple-500'
    },
    {
      icon: Building2,
      title: 'Enterprise Solutions',
      description: 'Custom ERP systems, workflow automation, and business intelligence dashboards for large organizations.',
      color: 'from-amber-500 to-orange-500'
    },
    {
      icon: Banknote,
      title: 'Financial Services',
      description: 'Secure banking applications, investment platforms, and blockchain-based financial solutions.',
      color: 'from-emerald-500 to-green-500'
    },
    {
      icon: PlayCircle,
      title: 'Media & Entertainment',
      description: 'Streaming platforms, content management systems, and interactive media applications.',
      color: 'from-red-500 to-rose-500'
    },
    {
      icon: TrendingUp,
      title: 'Data Analytics',
      description: 'Real-time analytics dashboards, predictive modeling, and business intelligence solutions.',
      color: 'from-blue-500 to-indigo-500'
    },
    {
      icon: Users,
      title: 'Social Platforms',
      description: 'Community building applications, social networks, and collaborative workspace solutions.',
      color: 'from-teal-500 to-cyan-500'
    }
  ];

  return (
    <section id="solutions" className="py-20 bg-dark-surface/50">
      <div className="max-w-7xl mx-auto content-padding">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-4">
            Industry <span className="brand-gradient">Solutions</span>
          </h2>
          <p className="text-lg text-dark-muted max-w-2xl mx-auto">
            Specialized applications designed to address the unique challenges and opportunities in various industries.
          </p>
        </div>

        {/* Solutions Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {solutions.map((solution, index) => {
            const Icon = solution.icon;
            return (
              <div
                key={index}
                className="group relative bg-dark-bg border border-dark-border rounded-xl p-6 hover:scale-105 transition-all duration-300"
              >
                {/* Gradient Background */}
                <div className={`absolute inset-0 bg-gradient-to-br ${solution.color} opacity-0 group-hover:opacity-10 rounded-xl transition-opacity duration-300`}></div>

                {/* Content */}
                <div className="relative z-10">
                  {/* Icon */}
                  <div className={`w-12 h-12 bg-gradient-to-br ${solution.color} rounded-lg flex items-center justify-center mb-4`}>
                    <Icon className="w-6 h-6 text-white" />
                  </div>

                  {/* Title */}
                  <h3 className="text-lg font-semibold mb-2">
                    {solution.title}
                  </h3>

                  {/* Description */}
                  <p className="text-dark-muted text-sm leading-relaxed">
                    {solution.description}
                  </p>
                </div>
              </div>
            );
          })}
        </div>

        {/* CTA */}
        <div className="text-center mt-12">
          <p className="text-dark-muted mb-4">
            Don't see your industry? We create custom solutions for any business vertical.
          </p>
          <button 
            onClick={() => document.getElementById('contact').scrollIntoView({ behavior: 'smooth' })}
            className="action-btn"
          >
            Discuss Your Project
          </button>
        </div>
      </div>
    </section>
  );
};

export default Solutions;

